interface MerchantStats {
  merchantName: string;
  visitCount: number;
  totalSpent: number;
}

interface MonthlySpend {
  month: string;
  amount: number;
}

export const getMostFrequentMerchant = (transactions: any[]): MerchantStats => {
  const merchantVisits = new Map<string, { count: number; total: number }>();

  transactions.forEach(transaction => {
    if (transaction.amount < 0) { // Only count spending transactions
      const merchant = transaction.merchant;
      const current = merchantVisits.get(merchant) || { count: 0, total: 0 };
      merchantVisits.set(merchant, {
        count: current.count + 1,
        total: current.total + Math.abs(transaction.amount)
      });
    }
  });

  let mostFrequent: MerchantStats = {
    merchantName: '',
    visitCount: 0,
    totalSpent: 0
  };

  merchantVisits.forEach((stats, merchant) => {
    if (stats.count > mostFrequent.visitCount) {
      mostFrequent = {
        merchantName: merchant,
        visitCount: stats.count,
        totalSpent: stats.total
      };
    }
  });

  return mostFrequent;
};

export const getMerchantMonthlySpending = (transactions: any[], merchantName: string): MonthlySpend[] => {
  // Create a map to store monthly totals
  const monthlyTotals = new Map<string, number>();

  // Filter transactions for the specific merchant and process them
  transactions
    .filter(t => t.merchant === merchantName && t.amount < 0)
    .forEach(transaction => {
      const date = new Date(transaction.date);
      const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      const currentTotal = monthlyTotals.get(monthKey) || 0;
      monthlyTotals.set(monthKey, currentTotal + Math.abs(transaction.amount));
    });

  // Convert the map entries to an array and sort by date
  const sortedMonths = Array.from(monthlyTotals.entries())
    .sort(([a], [b]) => a.localeCompare(b));

  // Format the data for display
  return sortedMonths.map(([monthKey, amount]) => {
    const [year, month] = monthKey.split('-');
    const date = new Date(parseInt(year), parseInt(month) - 1);
    return {
      month: date.toLocaleString('en-US', { month: 'short' }),
      amount: Math.round(amount)
    };
  });
};
